// Service-specific landing pages — each with content optimized for local SEO

export const services = [
  {
    slug: "psixologos-patra-katathlipsi",
    h1: "Ψυχολόγος για Κατάθλιψη στην Πάτρα",
    metaTitle: "Ψυχολόγος για Κατάθλιψη Πάτρα · CBT θεραπεία κατάθλιψης | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Θεραπεία κατάθλιψης στην Πάτρα με Γνωσιακή Συμπεριφορική Θεραπεία (CBT) — την πρώτης γραμμής, επιστημονικά τεκμηριωμένη προσέγγιση. Δια ζώσης ή online.",
    keywords:
      "ψυχολόγος κατάθλιψη Πάτρα, θεραπεία κατάθλιψης, σημάδια κατάθλιψης, CBT κατάθλιψη, ψυχοθεραπεία κατάθλιψης",
    intro:
      "Η κατάθλιψη δεν είναι «απλή στεναχώρια» ούτε αδυναμία χαρακτήρα — είναι μια από τις πιο συχνές και πιο θεραπεύσιμες δυσκολίες ψυχικής υγείας. Η Γνωσιακή Συμπεριφορική Θεραπεία (CBT) αποτελεί διεθνώς θεραπεία πρώτης γραμμής, με ισχυρή επιστημονική τεκμηρίωση.",
    sections: [
      {
        title: "Πώς εκδηλώνεται η κατάθλιψη",
        items: [
          "Επίμονη θλίψη ή «κενό» για περισσότερες από δύο εβδομάδες",
          "Απώλεια ενδιαφέροντος και ευχαρίστησης από πράγματα που αγαπούσες",
          "Διαταραχές ύπνου — αϋπνία ή υπερβολικός ύπνος, πρωινό ξύπνημα με βάρος",
          "Κόπωση, δυσκολία συγκέντρωσης, αίσθημα αναξιότητας ή ενοχής",
          "Απόσυρση από φίλους και δραστηριότητες, αλλαγές στην όρεξη",
        ],
      },
      {
        title: "Πώς δουλεύουμε με τη CBT",
        items: [
          "Συμπεριφορική ενεργοποίηση: ξαναχτίζουμε σταδιακά δραστηριότητες που δίνουν νόημα",
          "Εντοπισμός και επανεξέταση των αρνητικών μοτίβων σκέψης για τον εαυτό",
          "Μικρά, ρεαλιστικά βήματα — όχι πίεση για «γρήγορη λύση»",
          "Δουλειά με τον ύπνο, τη ρουτίνα και τη φροντίδα του εαυτού",
          "Πρόληψη υποτροπής: μαθαίνεις να αναγνωρίζεις έγκαιρα τα πρώιμα σημάδια",
        ],
      },
    ],
    duration: "Συνήθως 12–20 συνεδρίες για σταθερό αποτέλεσμα",
  },
  {
    slug: "psixologos-patra-agxos",
    h1: "Ψυχολόγος για Άγχος στην Πάτρα",
    metaTitle: "Ψυχολόγος για Άγχος Πάτρα · CBT για κρίσεις πανικού | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Εξειδικευμένη ψυχολογική υποστήριξη για άγχος και κρίσεις πανικού στην Πάτρα. Γνωσιακή Συμπεριφορική Θεραπεία (CBT). Δια ζώσης ή online.",
    keywords:
      "ψυχολόγος άγχος Πάτρα, κρίσεις πανικού, ψυχοθεραπεία άγχους, γενικευμένο άγχος, CBT άγχος",
    intro:
      "Το άγχος είναι ένας από τους πιο συχνούς λόγους που οι άνθρωποι αναζητούν ψυχολόγο στην Πάτρα. Στις περισσότερες περιπτώσεις, με σωστή θεραπεία, μπορείς να επανέλθεις σε μια ηρεμότερη και πιο λειτουργική καθημερινότητα μέσα σε μερικούς μήνες.",
    sections: [
      {
        title: "Πώς εκδηλώνεται το άγχος",
        items: [
          "Έντονη ανησυχία ή φόβος για το μέλλον, χωρίς συγκεκριμένη αιτία",
          "Κρίσεις πανικού: ταχυκαρδία, ζάλη, αίσθηση ότι «πεθαίνω» ή «τρελαίνομαι»",
          "Κοινωνικό άγχος — φόβος έκθεσης, αρνητικής αξιολόγησης",
          "Σωματικά συμπτώματα: σφιγμένοι ώμοι, ταχυπαλμίες, διαταραχές ύπνου",
          "Επαναλαμβανόμενες σκέψεις (μηρυκασμός) που δεν σταματούν",
        ],
      },
      {
        title: "Πώς δουλεύουμε με τη CBT",
        items: [
          "Ψυχοεκπαίδευση: κατανοούμε πώς λειτουργεί το άγχος στον δικό σου εγκέφαλο",
          "Εντοπισμός των αυτόματων αρνητικών σκέψεων που το τροφοδοτούν",
          "Τεχνικές αναπνοής, ηρεμίας και έκθεσης στις φοβικές καταστάσεις",
          "Σταδιακή πρακτική στην καθημερινότητα — όχι μόνο συζήτηση",
          "Πρόληψη υποτροπής: εργαλεία που σου μένουν για όλη τη ζωή",
        ],
      },
    ],
    duration: "Συνήθως 12–20 συνεδρίες για σταθερό αποτέλεσμα",
  },
  {
    slug: "psixologos-patra-ocd",
    h1: "Ειδικός για OCD στην Πάτρα",
    metaTitle: "Ψυχολόγος OCD Πάτρα · Ιδεοψυχαναγκαστική Διαταραχή | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Εξειδικευμένη θεραπεία για OCD (Ιδεοψυχαναγκαστική Διαταραχή) στην Πάτρα με Γνωσιακή Συμπεριφορική Θεραπεία και τεχνική ERP. Δια ζώσης ή online.",
    keywords:
      "OCD Πάτρα, ψυχολόγος OCD, ιδεοψυχαναγκαστική διαταραχή θεραπεία, ERP, ιδεοληψίες",
    intro:
      "Το OCD (Ιδεοψυχαναγκαστική Διαταραχή) είναι μια θεραπεύσιμη κατάσταση. Με τη σωστή προσέγγιση — Γνωσιακή Συμπεριφορική Θεραπεία και ειδικότερα την τεχνική ERP — οι περισσότεροι άνθρωποι βλέπουν σημαντική μείωση των συμπτωμάτων μέσα σε λίγους μήνες.",
    sections: [
      {
        title: "Συχνές μορφές OCD",
        items: [
          "Φόβος μόλυνσης και επαναλαμβανόμενο πλύσιμο",
          "Φόβος βλάβης ή λάθους (έλεγχος πόρτας, διακοπτών)",
          "«Απαγορευμένες» ιδεοληπτικές σκέψεις (σεξουαλικές, βίαιες, θρησκευτικές)",
          "Ανάγκη για συμμετρία και «σωστή» τάξη",
          "Νοητικό OCD (mental compulsions) — καθαρός μηρυκασμός χωρίς εξωτερικές πράξεις",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Λεπτομερής αξιολόγηση των ιδεοληψιών και των καταναγκασμών",
          "Ψυχοεκπαίδευση για τον κύκλο OCD",
          "Έκθεση με Πρόληψη Αντίδρασης (ERP) — ο gold standard για OCD",
          "Σταδιακή και ασφαλής εργασία στους τριγγερς, χωρίς ποτέ πίεση",
          "Πρακτικές ασκήσεις μεταξύ συνεδριών",
        ],
      },
    ],
    duration: "Συνήθως 16–24 συνεδρίες, ανάλογα με τη βαρύτητα",
  },
  {
    slug: "psixologos-patra-burnout",
    h1: "Ψυχολόγος για Burnout & Επαγγελματική Εξουθένωση στην Πάτρα",
    metaTitle: "Burnout Πάτρα · Επαγγελματική Εξουθένωση | Ψυχολόγος Άννα Παπαχρονόπουλου",
    metaDescription:
      "Επαγγελματική εξουθένωση (burnout); Υποστήριξη για στρες, υπερκόπωση και αποκατάσταση ισορροπίας στην Πάτρα και online.",
    keywords:
      "burnout Πάτρα, επαγγελματική εξουθένωση, στρες δουλειά, υπερκόπωση, ψυχολόγος burnout",
    intro:
      "Το burnout είναι κάτι παραπάνω από κούραση. Είναι μια κατάσταση χρόνιας συναισθηματικής, σωματικής και νοητικής εξάντλησης που σχετίζεται με την εργασία ή τις διαρκείς απαιτήσεις. Με τη σωστή υποστήριξη μπορείς να ανακτήσεις την ενέργεια και τη διαύγειά σου.",
    sections: [
      {
        title: "Σημάδια burnout",
        items: [
          "Διαρκής εξάντληση που δεν φεύγει με τον ύπνο ή τις διακοπές",
          "Κυνισμός ή αποστασιοποίηση από τη δουλειά / τους ανθρώπους",
          "Αίσθηση μειωμένης απόδοσης και αμφιβολίες αξίας",
          "Σωματικά συμπτώματα: πονοκέφαλοι, στομαχικά, αϋπνία",
          "Συναισθηματική «πλήξη» ή ευερεθιστότητα",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Χαρτογράφηση των πηγών στρες — τι είναι αλλαξιμο, τι όχι",
          "Δουλειά με τις «εσωτερικές απαιτήσεις» (perfectionism, υπερευθυνότητα)",
          "Πρακτικές αυτο-ρύθμισης και επαναφοράς ορίων",
          "Σταδιακή επανεγκατάσταση δραστηριοτήτων που σε γεμίζουν",
          "Πρόληψη υποτροπής σε επόμενα στρεσογόνα διαστήματα",
        ],
      },
    ],
    duration: "Συνήθως 8–16 συνεδρίες",
  },
  {
    slug: "online-psixologos-ellada",
    h1: "Online Ψυχολόγος στην Ελλάδα",
    metaTitle: "Online Ψυχολόγος Ελλάδα · Εξ αποστάσεως ψυχοθεραπεία CBT | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Online ψυχοθεραπεία CBT για όλη την Ελλάδα και το εξωτερικό. Άγχος, OCD, αυτοεκτίμηση, σχέσεις, τραύμα. Ασφαλής πλατφόρμα, ευέλικτες ώρες.",
    keywords:
      "online ψυχολόγος Ελλάδα, online ψυχοθεραπεία, εξ αποστάσεως ψυχολόγος, online CBT",
    intro:
      "Online συνεδρίες με την ίδια ποιότητα και αποτελεσματικότητα όπως οι δια ζώσης — από όπου κι αν βρίσκεσαι στην Ελλάδα ή το εξωτερικό. Η online ψυχοθεραπεία είναι επιστημονικά τεκμηριωμένη και ιδιαίτερα κατάλληλη για άτομα με βεβαρυμένο πρόγραμμα ή που μένουν σε περιοχές χωρίς εύκολη πρόσβαση σε εξειδικευμένο ψυχολόγο.",
    sections: [
      {
        title: "Πλεονεκτήματα της online θεραπείας",
        items: [
          "Ευελιξία ωραρίου — μπορείς να συνδυάσεις με τη δουλειά πιο εύκολα",
          "Πρόσβαση από Πάτρα, Αθήνα, Θεσσαλονίκη — ή από το εξωτερικό",
          "Ασφαλής, κρυπτογραφημένη πλατφόρμα video",
          "Συνέχεια θεραπείας ακόμη και όταν ταξιδεύεις",
          "Δυνατότητα συνεδριών στον δικό σου άνετο χώρο",
        ],
      },
      {
        title: "Τι χρειάζεσαι",
        items: [
          "Σταθερή σύνδεση internet",
          "Ένας ήσυχος, ιδιωτικός χώρος για τα 50 λεπτά",
          "Ακουστικά (συνιστώνται για καλύτερη ποιότητα)",
          "Ένα laptop, tablet ή κινητό με κάμερα",
        ],
      },
    ],
    duration: "Όσο και η δια ζώσης — εξαρτάται από το ζήτημα",
  },
  {
    slug: "psixologos-patra-koinoniko-agxos",
    h1: "Θεραπεία Κοινωνικού Άγχους στην Πάτρα",
    metaTitle: "Κοινωνικό Άγχος Πάτρα · Ψυχολόγος | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Θεραπεία για κοινωνικό άγχος στην Πάτρα. Φόβος έκθεσης, αρνητικής αξιολόγησης, αμηχανίας. Γνωσιακή Συμπεριφορική Θεραπεία (CBT) δια ζώσης ή online.",
    keywords:
      "κοινωνικό άγχος Πάτρα, ψυχολόγος κοινωνικό άγχος, social anxiety, φόβος έκθεσης, ντροπή",
    intro:
      "Το κοινωνικό άγχος δεν είναι απλά «ντροπαλότητα». Είναι μια έντονη ανησυχία ότι θα μας κρίνουν αρνητικά οι άλλοι — που μπορεί να μας κάνει να αποφεύγουμε καταστάσεις που πραγματικά θέλουμε να ζήσουμε. Η CBT είναι η πιο τεκμηριωμένη θεραπεία γι' αυτό.",
    sections: [
      {
        title: "Πώς εκδηλώνεται",
        items: [
          "Έντονος φόβος ομιλίας ή έκθεσης μπροστά σε άλλους",
          "Αποφυγή κοινωνικών εκδηλώσεων, παρουσιάσεων, νέων γνωριμιών",
          "Σωματικά: κοκκίνισμα, εφίδρωση, τρόμος, ταχυκαρδία",
          "Διαρκής αυτοκριτική και «καθρέφτισμα» μετά από κοινωνικές στιγμές",
          "Φόβος ότι «θα φανεί» πόσο αγχωμένος/η είμαι",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Κατανόηση των πεποιθήσεων που τροφοδοτούν το άγχος",
          "Σταδιακή έκθεση σε φοβικές καταστάσεις, με ασφάλεια",
          "Αναδιαμόρφωση των αυτόματων αρνητικών σκέψεων",
          "Πρακτικές δεξιότητες κοινωνικής αλληλεπίδρασης",
          "Καλλιέργεια αυτοαποδοχής αντί για τελειομανία",
        ],
      },
    ],
    duration: "Συνήθως 12–18 συνεδρίες",
  },
  {
    slug: "psixologos-patra-trauma",
    h1: "Ψυχοθεραπεία Τραύματος στην Πάτρα",
    metaTitle: "Τραύμα Πάτρα · Ψυχολόγος για δύσκολες εμπειρίες | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Επεξεργασία τραυματικών εμπειριών, απώλειας και έντονων συναισθημάτων στην Πάτρα. Ασφαλές, σταθερό θεραπευτικό πλαίσιο με σεβασμό στον προσωπικό σου ρυθμό.",
    keywords:
      "τραύμα Πάτρα, ψυχολόγος τραύμα, ψυχοθεραπεία τραύματος, PTSD, απώλεια, πένθος",
    intro:
      "Το τραύμα δεν είναι μόνο τα «μεγάλα» γεγονότα. Μπορεί να είναι μια μακροχρόνια δύσκολη σχέση, μια απώλεια, μια εμπειρία που έμεινε ανεπεξέργαστη. Η θεραπεία για το τραύμα γίνεται με σεβασμό στον δικό σου ρυθμό — κανείς δεν επεξεργάζεται με πίεση.",
    sections: [
      {
        title: "Πιθανές εκδηλώσεις τραύματος",
        items: [
          "Επαναλαμβανόμενες σκέψεις ή αναμνήσεις του γεγονότος",
          "Αποφυγή καταστάσεων ή ανθρώπων που το θυμίζουν",
          "Υπερεγρήγορση — αίσθηση ότι «κάτι κακό θα συμβεί»",
          "Αίσθηση μουδιάσματος ή αποσύνδεσης από τον εαυτό",
          "Διαταραχές ύπνου, εφιάλτες",
          "Ενοχή ή ντροπή που δεν δικαιολογούνται",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Πρώτα η σταθερότητα — δουλειά στην ασφάλεια και τη ρύθμιση πριν την έκθεση",
          "Ψυχοεκπαίδευση για τις φυσιολογικές αντιδράσεις του εγκεφάλου στο τραύμα",
          "Αργή, ασφαλής επεξεργασία της εμπειρίας — όχι αναβίωση",
          "Δεξιότητες ηρεμίας και grounding για στιγμές υπερφόρτισης",
          "Επανασύνδεση με την παρούσα ζωή και τους στόχους σου",
        ],
      },
    ],
    duration: "Εξαρτάται από τη φύση του τραύματος — συνήθως 6+ μήνες",
  },
  {
    slug: "psixologos-patra-yperfagia",
    h1: "Συναισθηματική Υπερφαγία στην Πάτρα",
    metaTitle: "Συναισθηματική Υπερφαγία Πάτρα · Ψυχολόγος | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Θεραπεία για συναισθηματική υπερφαγία και διατροφικές δυσκολίες στην Πάτρα. Αποκατάσταση μιας ήρεμης σχέσης με το φαγητό και το σώμα.",
    keywords:
      "συναισθηματική υπερφαγία, διατροφικές διαταραχές Πάτρα, binge eating, σχέση με φαγητό",
    intro:
      "Όταν τρώμε επειδή αγχωνόμαστε, στενοχωριόμαστε ή βαριόμαστε — αυτή είναι η συναισθηματική υπερφαγία. Δεν είναι έλλειψη πειθαρχίας. Είναι μια προσπάθεια του εγκεφάλου να ρυθμίσει συναισθήματα. Η CBT μας βοηθά να βρούμε άλλους τρόπους.",
    sections: [
      {
        title: "Σημάδια",
        items: [
          "Φαγητό όταν δεν πεινάς πραγματικά",
          "Επεισόδια έντονης κατανάλωσης φαγητού («binge»)",
          "Ντροπή ή ενοχή μετά το φαγητό",
          "Κρυφό φαγητό, ατομικό φαγητό",
          "Φαγητό ως «ανταμοιβή» ή ως παρηγοριά",
          "Κύκλοι αυστηρής δίαιτας και υπερφαγίας",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Χαρτογράφηση των τροφικών συμπεριφορών χωρίς αυτοκριτική",
          "Διαχωρισμός σωματικής πείνας από συναισθηματική",
          "Ταυτοποίηση των συναισθημάτων που πυροδοτούν το επεισόδιο",
          "Εναλλακτικοί τρόποι ρύθμισης συναισθημάτων",
          "Δουλειά στη σχέση με το σώμα και την αυτοεικόνα",
        ],
      },
    ],
    duration: "Συνήθως 16–24 συνεδρίες",
  },
  {
    slug: "psixologos-patra-sxeseis",
    h1: "Θεραπεία για Σχέσεις & Δεσμό στην Πάτρα",
    metaTitle: "Σχέσεις & Δεσμός · Ψυχοθεραπεία Πάτρα | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Ατομική θεραπεία για ζητήματα σχέσεων, δεσμού και επικοινωνίας στην Πάτρα. Κατανόηση των μοτίβων που επαναλαμβάνονται στις σχέσεις σου.",
    keywords:
      "σχέσεις Πάτρα, ψυχολόγος σχέσεις, attachment, δεσμός, συντροφικές σχέσεις, επικοινωνία",
    intro:
      "Οι σχέσεις μας — με συντρόφους, οικογένεια, φίλους — αντικατοπτρίζουν συχνά τα παλαιά μας μοτίβα δεσμού. Στη θεραπεία εξετάζουμε γιατί επαναλαμβάνουμε ορισμένες δυναμικές και πώς μπορούμε να χτίσουμε πιο υγιείς συνδέσεις.",
    sections: [
      {
        title: "Συχνά ζητήματα",
        items: [
          "Επαναλαμβανόμενα μοτίβα σε σχέσεις (πχ συντροφικές)",
          "Φόβος εγκατάλειψης ή υπερβολική προσκόλληση",
          "Δυσκολία στην εμπιστοσύνη ή τη συναισθηματική εγγύτητα",
          "Συγκρούσεις με γονείς, αδέρφια, συγγενείς",
          "Καθορισμός ορίων στις σχέσεις",
          "Επικοινωνία και διαχείριση συγκρούσεων",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Χαρτογράφηση των επαναλαμβανόμενων μοτίβων",
          "Κατανόηση του τύπου δεσμού σου (attachment style)",
          "Δουλειά με τις «εσωτερικές φωνές» που επηρεάζουν τις σχέσεις",
          "Πρακτικές δεξιότητες υγιούς επικοινωνίας",
          "Καλλιέργεια αυτοφροντίδας μέσα στις σχέσεις",
        ],
      },
    ],
    duration: "Συνήθως 12–24 συνεδρίες",
  },
  {
    slug: "psixologos-patra-aftoektimisi",
    h1: "Θεραπεία Αυτοεκτίμησης στην Πάτρα",
    metaTitle: "Αυτοεκτίμηση Πάτρα · Ψυχολόγος | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Δουλεύουμε πάνω στην εικόνα του εαυτού, την αυτοπεποίθηση και τα εσωτερικά μοτίβα. Θεραπεία αυτοεκτίμησης στην Πάτρα ή online.",
    keywords:
      "αυτοεκτίμηση Πάτρα, αυτοπεποίθηση, εσωτερικός κριτής, αυτοαξία, ψυχολόγος αυτοεκτίμηση",
    intro:
      "Η χαμηλή αυτοεκτίμηση είναι σαν ένας εσωτερικός κριτής που δεν σταματά ποτέ να σχολιάζει. Επηρεάζει τις επιλογές, τις σχέσεις, τη δουλειά μας. Μπορείς να μάθεις να ζεις με έναν πιο ευγενικό εαυτό. Αυτή είναι η ουσία του «psyloveyourself».",
    sections: [
      {
        title: "Πώς εκδηλώνεται",
        items: [
          "Σκληρή αυτοκριτική για κάθε λάθος",
          "Δυσκολία να δεχτείς κομπλιμέντα ή επιτυχία",
          "Σύγκριση με άλλους — ποτέ «αρκετός/ή»",
          "Αναβλητικότητα και φόβος αποτυχίας",
          "Επαναλαμβανόμενες αρνητικές σχέσεις",
          "Τελειομανία και «syndrome impostor»",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Χαρτογράφηση του εσωτερικού κριτή — από πού έρχεται",
          "Καλλιέργεια αυτοσυμπόνιας (self-compassion)",
          "Δουλειά στις βασικές πεποιθήσεις για τον εαυτό",
          "Αναγνώριση και τίμημα των επιτευγμάτων σου",
          "Σταδιακή κατασκευή υγιούς αυτοεικόνας",
        ],
      },
    ],
    duration: "Συνήθως 16–24 συνεδρίες",
  },
  {
    slug: "psixologos-patra-efivoi",
    h1: "Ψυχοθεραπεία Εφήβων στην Πάτρα",
    metaTitle: "Ψυχολόγος Εφήβων Πάτρα | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Ψυχολογική υποστήριξη για εφήβους στην Πάτρα: ταυτότητα, σχέσεις, σχολείο, συναισθηματική διαχείριση. Ασφαλές, αμερόληπτο πλαίσιο.",
    keywords:
      "ψυχολόγος εφήβων Πάτρα, ψυχοθεραπεία εφήβων, εφηβεία, σχολικό άγχος, ταυτότητα εφήβου",
    intro:
      "Η εφηβεία είναι μια από τις πιο πυκνές περιόδους της ζωής. Σώμα, ταυτότητα, σχέσεις, ακαδημαϊκές πιέσεις — όλα μαζί. Στις συνεδρίες με εφήβους δίνω έμφαση στον σεβασμό της ιδιωτικότητάς τους, ώστε να αισθάνονται πραγματικά ότι ο χώρος είναι δικός τους.",
    sections: [
      {
        title: "Συχνά θέματα",
        items: [
          "Άγχος, κρίσεις πανικού, σχολικό άγχος",
          "Ζητήματα ταυτότητας και σώματος",
          "Σχέσεις με συμμαθητές — μοναξιά, bullying",
          "Συγκρούσεις με γονείς",
          "Αυτοτραυματιστικές συμπεριφορές",
          "Διαταραχές διάθεσης ή διατροφικές δυσκολίες",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Πρώτη συνάντηση με γονείς και έφηβο μαζί — μετά μόνο με τον/την έφηβο",
          "Σαφές πλαίσιο εμπιστευτικότητας (τι μένει στις συνεδρίες)",
          "Δουλειά με βάση την CBT, προσαρμοσμένη στην ηλικία",
          "Δραστηριότητες, σχέδιο, παιχνίδι όπου χρειάζεται",
          "Περιοδική επικοινωνία με γονείς (με τη συγκατάθεση του εφήβου)",
        ],
      },
    ],
    duration: "Συνήθως 12–20 συνεδρίες",
  },
  {
    slug: "psixologos-patra-zeugous",
    h1: "Ψυχοθεραπεία Ζεύγους στην Πάτρα",
    metaTitle: "Θεραπεία Ζεύγους Πάτρα · Ψυχολόγος | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Θεραπεία ζεύγους στην Πάτρα: επικοινωνία, εμπιστοσύνη, συναισθηματική σύνδεση. Δουλειά πάνω στις προσδοκίες και την ανανέωση του δεσμού.",
    keywords:
      "ψυχοθεραπεία ζεύγους Πάτρα, θεραπεία ζευγαριών, σχέσεις ζευγαριών, couples therapy, χωρισμός",
    intro:
      "Καμία σχέση δεν είναι «τέλεια» — και αυτό δεν σημαίνει ότι κάτι πάει στραβά. Σημαίνει απλά ότι δύο διαφορετικοί άνθρωποι μοιράζονται μια ζωή. Η θεραπεία ζεύγους βοηθά να ακούσουμε ξανά ο ένας τον άλλο, να καταλάβουμε τα μοτίβα μας και να ξαναβρούμε τη σύνδεση.",
    sections: [
      {
        title: "Πότε βοηθά",
        items: [
          "Συχνές συγκρούσεις χωρίς λύση",
          "Αίσθηση ότι «μιλάμε σε άλλη γλώσσα»",
          "Απομάκρυνση και έλλειψη οικειότητας",
          "Παραβίαση εμπιστοσύνης (απιστία, μυστικά)",
          "Αλλαγές φάσης ζωής (γέννηση παιδιού, μετακόμιση)",
          "Σκέψεις χωρισμού — να δοκιμάσουμε πριν αποφασίσουμε",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Πρώτη συνάντηση και οι δύο μαζί",
          "Συχνά μία ατομική συνεδρία ανά πλευρά για να ακουστούν όλοι",
          "Δουλειά με τις δυναμικές της σχέσης — όχι «ποιος έχει δίκιο»",
          "Δεξιότητες υγιούς διαφωνίας και αποκατάστασης",
          "Επαναπροσδιορισμός κοινών στόχων και αξιών",
        ],
      },
    ],
    duration: "Συνήθως 8–16 συνεδρίες",
  },
  {
    slug: "psixologos-patra-symvouleftiki-goneon",
    h1: "Συμβουλευτική Γονέων στην Πάτρα",
    metaTitle: "Συμβουλευτική Γονέων Πάτρα · Ψυχολόγος | Άννα Παπαχρονόπουλου",
    metaDescription:
      "Πρακτική και θεραπευτική υποστήριξη σε γονείς στην Πάτρα: όρια, ανατροφή, επικοινωνία, διαχείριση δύσκολων φάσεων.",
    keywords:
      "συμβουλευτική γονέων Πάτρα, γονείς, ανατροφή παιδιών, όρια, δύσκολο παιδί, parenting",
    intro:
      "Είναι σκληρή δουλειά να είσαι γονιός. Δεν υπάρχει εγχειρίδιο — και κάθε παιδί είναι διαφορετικό. Η συμβουλευτική γονέων είναι ένας χώρος όπου μπορείς να μιλήσεις χωρίς κρίση, να καταλάβεις τι συμβαίνει με το παιδί σου και να βρεις πρακτικά εργαλεία για την καθημερινότητα.",
    sections: [
      {
        title: "Συχνά αιτήματα",
        items: [
          "Διαχείριση εκρήξεων θυμού ή έντονων αντιδράσεων",
          "Ζητήματα ορίων και πειθαρχίας",
          "Αδερφικές συγκρούσεις",
          "Σχολική αρνητική στάση ή χαμηλή απόδοση",
          "Άγχος ή φόβοι του παιδιού",
          "Διαζύγιο — πώς να το ανακοινώσουμε και πώς να στηρίξουμε",
          "Έφηβα παιδιά και η αλλαγή στη σχέση",
        ],
      },
      {
        title: "Πώς δουλεύουμε",
        items: [
          "Συνεδρίες χωρίς το παιδί — εστίαση σε εσένα ως γονιό",
          "Κατανόηση των αναπτυξιακών σταδίων του παιδιού",
          "Πρακτικά εργαλεία επικοινωνίας ηρεμίας και ορίων",
          "Δουλειά με τις δικές σου εμπειρίες και τα μοτίβα ανατροφής που κουβαλάς",
          "Συντονισμός μεταξύ των δύο γονιών (όπου χρειάζεται)",
        ],
      },
    ],
    duration: "Συνήθως 6–12 συνεδρίες",
  },
];

export const getServiceBySlug = (slug) =>
  services.find((s) => s.slug === slug);
